import { Injectable } from '@angular/core';
import { RequestsProvider } from '../requests/requests';
import { environment } from '../../../../environments/environment';
import { LoggerFactory } from '../logger/logger-factory.service';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { ReportingsP1ControllerApi } from '../../../api/services/reportings-p-1-controller-api';
import { firstValueFrom } from 'rxjs';
import { GetAlertTemperatureByDkCodesEmplacements$Params } from '../../../api/fn/reportings-p-1-controller/get-alert-temperature-by-dk-codes-emplacements';
import { AlertesEmplacementDto } from '../../../api/models/alertes-emplacement-dto';
import { SiteAlerteDto } from '../../../api/models/site-alerte-dto';
import { GetSitesAlertesTemperatureByDkCodesEmplacements$Params } from '../../../api/fn/reportings-p-1-controller/get-sites-alertes-temperature-by-dk-codes-emplacements';

export interface TemperatureAmbiante {
  statut_impact_reduits: string;
  libelle_systeme_elementaire: string;
  temperature_contrat_confort: number;
  temperature_contrat_reduit: number;
  temperature_reelles_confort: number;
  temperature_reelles_reduit: number;
  impact_des_reduits: number;
}

export interface Consommations {
  date_conduite: string;
  conso_reelle_mois: number;
  ecart_mwh_mois: number;
  ecart_pourcent_mois: number;
  conso_reelle_annee: number;
  ecart_mwh_annee: number;
  ecart_pourcent_annee: number;
}

@Injectable({ providedIn: 'root' })
export class ReportingP1Service {
  apiUrlDactechBack = '';

  private logger: LoggerWrapper;

  constructor(
    private readonly requestsProvider: RequestsProvider,
    private readonly loggerFactory: LoggerFactory,
    private readonly reportingsP1Api: ReportingsP1ControllerApi
  ) {
    this.logger = this.loggerFactory.getInstance(this);
    this.apiUrlDactechBack = environment.apis.API_DACTECH_BACK_V1;
  }

  getCategoriesReportingP1(dkCodeInstallations: string[]) {
    if (dkCodeInstallations.length == 0) return [];
    return this.requestsProvider
      .post(this.apiUrlDactechBack + '/reportings_p1/categories', dkCodeInstallations, {
        'Content-Type': 'application/json',
      })
      .then((data) => {
        return data;
      })
      .catch((err) => {
        this.logger.warn('error getCategoriesReportingP1', err);
        return false;
      });
  }

  getTemperaturesAmbiantes(dkCodeInstallation: string): Promise<TemperatureAmbiante[]> {
    return this.requestsProvider
      .get(this.apiUrlDactechBack + `/reportings_p1/t_ambiantes?dkCodeInstallation=${dkCodeInstallation}`, {
        'Content-Type': 'application/json',
      })
      .then((data) => {
        return data as TemperatureAmbiante[];
      })
      .catch((err) => {
        this.logger.warn('error getTemperaturesAmbiantes', err);
        throw new Error(err);
      });
  }

  getConsommations(dkCodeInstallation: string): Promise<Consommations> {
    return this.requestsProvider
      .get(this.apiUrlDactechBack + `/reportings_p1/consommations?dkCodeInstallation=${dkCodeInstallation}`, {
        'Content-Type': 'application/json',
      })
      .then((data) => {
        return data as Consommations;
      })
      .catch((err) => {
        this.logger.warn('error getConsommations', err);
        throw new Error(err);
      });
  }

  getAlertesTemperature(dkCodesEmplacements: string[]): Promise<AlertesEmplacementDto> {
    try {
      const params: GetAlertTemperatureByDkCodesEmplacements$Params = {
        body: dkCodesEmplacements,
      };
      return firstValueFrom(this.reportingsP1Api.getAlertTemperatureByDkCodesEmplacements(params));
    } catch (e) {
      this.logger.error(
        e,
        `une erreur est survenue lors de la récupération des alertes températures pour les emplacements: ${dkCodesEmplacements}`
      );
      return Promise.reject(
        `une erreur est survenue lors de la récupération des alertes températures pour les emplacements: ${dkCodesEmplacements}`
      );
    }
  }

  getSitesAlertesTemperatureByDkCodesEmplacements(dkCodesEmplacements: string[]): Promise<SiteAlerteDto[]> {
    try {
      const params: GetSitesAlertesTemperatureByDkCodesEmplacements$Params = {
        body: dkCodesEmplacements,
      };
      return firstValueFrom(this.reportingsP1Api.getSitesAlertesTemperatureByDkCodesEmplacements(params));
    } catch (e) {
      this.logger.error(
        e,
        `une erreur est survenue lors de la récupération des emplacements en alerte : ${dkCodesEmplacements}`
      );
      return Promise.reject(
        `une erreur est survenue lors de la récupération des emplacements en alerte : ${dkCodesEmplacements}`
      );
    }
  }
}
